import React from 'react';
import { Link } from 'react-router-dom';

const RECENT_KEY = 'quantumtrade.recentSymbols';

function rememberRecent(symbol) {
  if (typeof window === 'undefined') return;
  try {
    const existing = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
    const next = [symbol, ...existing.filter((item) => item !== symbol)].slice(0, 8);
    window.localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {}
}

export default function StockLink({ symbol, className = '', children }) {
  if (!symbol) return children || null;
  return (
    <Link
      to={`/stocks/${symbol}`}
      className={`stock-link ${className}`}
      title="Open stock analyzer"
      onClick={() => rememberRecent(symbol)}
    >
      {children || symbol}
    </Link>
  );
}
